import { styles as componentStyles } from './view.scss';
import { unsafeCSS } from 'lit';
import { GzDonutChartWidgetWebComponent } from '../../../../ui/gzDonutChartWidget';

export const styles = [
  ...GzDonutChartWidgetWebComponent.styles,
  unsafeCSS(`${componentStyles}`),
];
